// RecordsDeliveryDownloadPage — the public landing page for a secure single-use
// records-delivery link (MRR P3.4). NO authentication: the token in the URL is
// the authorization. This page does NOTHING but forward the browser to the
// backend's unauthenticated /api/records-delivery/:token endpoint, which validates
// the token (hash, single-use, expiry, practice scope) and 302-redirects to a
// fresh signed S3 URL of the merged-PDF artifact. Keeping the redirect on the API
// (not fetching the PDF in JS) means the single-use token is spent exactly once,
// by the real download, and no PHI ever touches this page.

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function RecordsDeliveryDownloadPage() {
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    if (token) {
      // Full-page navigation to the API endpoint, which 302s to the signed S3 URL.
      window.location.replace(`${API_URL}/api/records-delivery/${encodeURIComponent(token)}`);
    }
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center px-6">
        <div className="w-8 h-8 mx-auto mb-4 border-2 border-gray-300 border-t-[#C94B1F] rounded-full animate-spin" />
        <h1 className="text-base font-semibold text-gray-900">Preparing your secure download…</h1>
        <p className="text-sm text-gray-500 mt-2">
          Your medical records download should begin automatically. If it does not,
          the link may have expired or already been used.
        </p>
      </div>
    </div>
  );
}
